import { Fragment, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { baseUrl } from 'utils';
import axios from 'axios';

import styles from './Footer.module.scss';

import { LanguageBtn } from './parts';

export const Footer = () => {
  const [docs, setDocs] = useState([]);

  useEffect(() => {
    axios.get(`${baseUrl}/items/legal_documents/`).then(response => {
      const data = response.data.data;
      setDocs(data);
    });
  }, []);

  const getDocsByType = type => {
    const filteredAndSortDocs = docs
      .filter(item => item.document_type == type)
      .sort((a, b) => a.language.localeCompare(b.language));

    const result = filteredAndSortDocs.map((item, index) => {
      if (filteredAndSortDocs.length <= 1 && item.language === 'fr') {
        return (
          <Fragment key={index}>
            <div></div>
            <a
              target="_blank"
              rel="noopener noreferrer"
              href={`${baseUrl}/legal-docs/${item.document_type}/${item.language}`}
              className={styles.type}
            >
              {item.title}
            </a>
          </Fragment>
        );
      }
      return (
        <a
          target="_blank"
          rel="noopener noreferrer"
          href={`${baseUrl}/legal-docs/${item.document_type}/${item.language}`}
          className={styles.type}
          key={index}
        >
          {item.title}
        </a>
      );
    });
    return result;
  };

  const { t } = useTranslation();

  return (
    <div className={styles.root}>
      <div className={styles.docs}>
        <div className={styles.languages}>
          <div className={styles.language}>EN</div>
          <div className={styles.language}>FR</div>
        </div>
        <div className={styles.group}>{getDocsByType('terms')}</div>
        <div className={styles.group}>{getDocsByType('privacy')}</div>
        <div className={styles.group}>{getDocsByType('legal')}</div>
      </div>
      <div className={styles.lang}>
        <LanguageBtn language="en-US" />
        <LanguageBtn language="fr-FR" />
      </div>

      <div className={styles.copyright}>{t('copyright')}</div>
    </div>
  );
};
